import { FC, ReactNode } from 'react';
import { TextField, StandardTextFieldProps } from '@mui/material';
import { useField, useFormikContext } from 'formik';

interface SelectProps extends StandardTextFieldProps {
  name: string;
  children: ReactNode;
}

export const Select: FC<SelectProps> = ({ name, children, ...props }) => {
  const { setFieldValue } = useFormikContext();
  const [field, meta] = useField(name);

  const handleChange = (event: React.SyntheticEvent): void => {
    let target = event.target as HTMLInputElement;
    const { value } = target;
    setFieldValue(name, value);
  };

  const config = {
    fullWidth: true,
    size: 'small' as 'small',
    ...field,
    ...props,
    label: props.label,
    select: true,
    onChange: props.onChange ?? handleChange,
  };

  if (meta.touched && meta.error) {
    config.error = true;
    config.helperText = meta.error;
  }

  return <TextField {...config}>{children}</TextField>;
};
